export default __webpack_public_path__ + "852bb041fb08356f846f63755442453f.svg";